const PSPConfigurationController = function ($scope, $http) {
    $http.get('/api/v1/PSPConfiguration/creditCards').then(function (response) {
        $scope.providers = response.data;
        $scope.selectedProvider = $scope.providers[0];
    });

    $scope.saveSupportedCreditCards = function () {
        if (!$scope.inRoleSuperAdmin())
            alert("You don't have permissions to perform this request");
        
        $http.put('/api/v1/PSPConfiguration/creditCards', $scope.providers)
            .then(function () {
                $scope.notify("success", "Saved successfully.");
            });
    }
};

PSPConfigurationController.$inject = ["$scope", "$http"];

angular.module('globalControllers', [])
    .controller('PSPConfigurationController', PSPConfigurationController);
